import { app } from '../app'
import { createApp } from 'vue'
import { vuetify } from '../vuetify'
import { errorMixin } from '../mixins/error-mixin'
import { i18n } from '../i18n'
import VContactForm from '../components/VContactForm.vue'
import VPhotoGallery from "../components/VPhotoGallery.vue";
// @ts-ignore
import GLightbox from 'glightbox'

createApp({
  components: {
    VContactForm,
    VPhotoGallery
  },
  extends: app,
  mixins: [
    errorMixin
  ],
  mounted () {
    this.$nextTick(() => {
      const lightbox = GLightbox({
        touchNavigation: true,
        loop: true,
        autoplayVideos: true,
        selector: '.glightbox'
      })
    })

  },
})
  .use(vuetify)
  .use(i18n)
  .mount('#app')
